// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    count: 0,
    persona: {},
    personaHistories: [],
    personas: [],
};

const slice = createSlice({
    name: 'persona',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // GET ORDERS
        getPersonasSuccess(state, action) {
            state.personas = action.payload.personaList;
            state.count = action.payload.total;
        },

        // GET ORDER
        getPersonaSuccess(state, action) {
            state.persona = action.payload.persona;
            state.personaHistories = action.payload.personaHistoryList;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getPersonas(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/persona/list', data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            dispatch(slice.actions.getPersonasSuccess(response.data));
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function createPersona(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/persona/add', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }
            );
            if(callback){
                callback(response.data.persona.id);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPersona(id, callback) {
    return async () => {
        try {
            const response = await axios.get('/api/persona/details/'+id, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            dispatch(slice.actions.getPersonaSuccess(response.data));
            if(callback){
                callback(response.data.persona);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };

}

export function editPersona(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/persona/edit', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            dispatch(slice.actions.getPersonaSuccess(response.data));
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addHistory(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/persona/history/add', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            dispatch(slice.actions.getPersonaSuccess(response.data));
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function pushToProduction(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/persona/production', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            dispatch(slice.actions.getPersonaSuccess(response.data));
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function archiveHistory(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/persona/history/archive', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            dispatch(slice.actions.getPersonaSuccess(response.data));
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


